import "./HomeView.css";

import Component from "../components/Component";
import Spinner from "../components/Spinner";

export default class HomeView extends Component {


    connectedCallback(): void {
        this.replaceChildren(
            new Spinner()
        )
    }

}

customElements.define("home-view", HomeView);
